<template>
  <div class="export-pdf-container">
    <div class="content one-page rating-system">
      <div class="content-rating">
        <!--<img class="main-img" :src="'img/imgPdf/rating-system.jpg'" alt="" />-->
        <p class="box-logo-upm">
          <img :src="'img/imgPdf/upm-page1.png'" alt="" />
        </p>
        <div class="box-fact-file">
          <p class="fact-file">Fact file</p>
          <p class="institutional">Program Level</p>
        </div>
        <div class="box-program-name">
          <div class="box-program-name-left">
            <p class="program-name">{{ programData.name }}</p>
            <p class="university-of-program-name">
              {{ programData.university_name }}
            </p>
            <p class="program-country">{{ programData.nation }}</p>
          </div>
          <img
            :src="
              `img/icon-rating/${getStarImg(
                programData.program_type_id === 1 ? 'research' : 'applied',
                programSummaryRatingData.star,
                programSummaryRatingData.extra
              )}`
            "
            alt=""
            class="rating-img rating-img-program"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RatingSystem",
  data() {
    return {
      programData: {
        name: "",
        university_name: "",
        nation: "",
        program_type_id: "",
        program_type: {
          name: ""
        }
      },
      programSummaryRatingData: {
        star: 0,
        extra: null
      }
    };
  },
  props: {
    programInfo: {
      type: Object
    },
    programSummaryRating: {
      type: Object
    }
  },
  watch: {
    programInfo: {
      handler(newVal) {
        this.programData.name = newVal.name;
        this.programData.university_name = newVal.university_name;
        this.programData.nation = newVal.nation;
        this.programData.program_type_id = newVal.program_type_id;
        this.programData.program_type = newVal.program_type;
      },
      deep: true,
      immediate: true
    },
    programSummaryRating: {
      handler(newVal) {
        this.programSummaryRatingData.extra = newVal.extra;
        this.programSummaryRatingData.star = newVal.star;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.programData.name = this.programInfo.name;
    this.programData.university_name = this.programInfo.university_name;
    this.programData.nation = this.programInfo.nation;
    this.programData.program_type_id = this.programInfo.program_type_id;
    this.programData.program_type = this.programInfo.program_type;
    this.programSummaryRatingData.extra = this.programSummaryRating.extra;
    this.programSummaryRatingData.star = this.programSummaryRating.star;
  },
  methods: {
    getStarImg(divisionName, star = "", extra = "") {
      const displayStar =
        star && star >= 1 ? Math.floor(star / 1).toFixed(0) : 1;
      return `${divisionName}_${_.toLower(extra)}${displayStar}.png`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/program-pdf.scss";
</style>
